import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { globalProperties } from '@/main.js';
import store from '@/store.js';
const chips = {
  success: {
    class: 'text-second-100 bg-second-100/15',
    icon: 'icon-check text-xs'
  },
  warning: {
    class: 'text-cta2-100 bg-cta2-100/15',
    icon: 'icon-less text-xs'
  },
  neutral: {
    class: 'text-main-100 bg-main-100/15',
    icon: 'icon-less text-xs'
  },
  error: {
    class: 'text-cta-100 bg-cta-100/15',
    icon: 'icon-no-results text-xs'
  }
};
const logStreamsColors = {
  error: 'error',
  warn: 'cta2',
  log: 'second',
  trace: 'main'
};
export const FlowDetailsController = {
  NormalizeLogData: response => {
    if (response.stoppedByUser) {
      response.status = 202;
    } // stopped by user
    else if (response.result === 0 || response.result === 'Success') {
      response.status = 200;
    } // success
    else if (response.result === 1 || response.result === 'Fail') {
      response.status = 500;
    } // server error
    else if (response.result === 2 || response.result === 'WrongInput') {
      response.status = 400;
    } // wrong input, file open or wrong columns
    else if (response.result === 3 || response.result === 'NotEnoughSlans') {
      response.status = 402;
    } // usage limit reached
    else if (response.result === 4 || response.result === 'FlowAborted') {
      response.status = 299;
    } // execution aborted

    response.createdAtString = globalProperties.$formatDate({
      date: response.createAt || new Date(),
      format: 'dd/mm/yy hh:mm'
    }).replace(' ', ' • ');
    response.relation = (response.successfulIterations / response.totalIterations * 100).toFixed(1);
    response.executionType = response.browserFlowSchedule?.machine ? 'Lanzamiento remoto' : response.scheduled ? 'Programado' : 'Manual';
    if (response.status === 200) response.statusChip = 'icon-check text-lg in-[*]:bg-cta-100';else if (response.status === 202 || response.status === 402) response.statusChip = {
      class: 'text-4xl text-cta2-100 bg-cta2-100/15',
      icon: 'icon-less'
    };else response.statusChip = {
      class: 'text-lg text-second-100 bg-second-100/15',
      icon: 'icon-check'
    };
    if (response.status in FlowDetailsController.infoByStatus) response.infoByStatus = FlowDetailsController.infoByStatus[response.status];
    response.usedMachine = response.browserFlowSchedule?.machine;
    response.isLocal = !response.scheduled || !response.usedMachine;
    response.cost = 0;
    response.robotName = globalProperties.$getParameterCaseInsensitive(response.browserFlow, 'name');
    const logStreamVariableKey = globalProperties.$getParameterCaseInsensitive(response.browserFlow, 'logStreamVariableKey');
    if (logStreamVariableKey && logStreamVariableKey in response.logStreams) {
      response.normalizedUserLogStreams = response.logStreams[logStreamVariableKey].filter(l => {
        l.color = logStreamsColors[l.level];
        return l.level;
      });
    } // Log stream normalization

    if (response.usageHistory?.usageUnits && response.usageHistory?.usageRatio) {
      response.cost = response.usageHistory.usageUnits * response.usageHistory.usageRatio;
    } // Usage

    return response;
  },
  get infoByStatus() {
    const cur = store.state.appConfig?.currencies ?? '';
    return {
      200: {
        text: 'Finalizado',
        description: 'El robot se ha ejecutado correctamente',
        color: 'error',
        chip: chips.success
      },
      202: {
        text: 'Robot detenido',
        description: 'El robot ha sido detenido por el usuario',
        color: 'main',
        chip: chips.neutral
      },
      400: {
        text: 'Entradas incorrectas',
        description: 'Las entradas del robot no son válidas',
        color: 'error',
        chip: chips.warning
      },
      402: {
        text: `Insuficientes ${cur}`,
        description: `No dispones de ${cur}`,
        color: 'main',
        chip: chips.warning
      },
      299: {
        text: 'Robot interrumpido',
        description: 'Robot interrumpido en su ejecución',
        color: 'error',
        chip: chips.error
      },
      500: {
        text: '',
        description: 'El robot no se ha lanzado correctamente',
        color: 'error',
        chip: chips.error
      }
    };
  }
};
export default {
  data: function () {
    return {
      open: false
    };
  },
  computed: {
    hasInfoMessages() {
      return !!this.currentLog?.normalizedUserLogStreams?.length;
    },
    logs() {
      return this.$state.ui.robotLogs;
    },
    currentLog() {
      const log = this.logs?.[0];
      if (!log) return;
      if (!log.status) {
        FlowDetailsController.NormalizeLogData(log);
      }
      return log;
    }
  },
  watch: {
    currentLog(new_, old_) {
      // eslint-disable-line

      old_?.timer?.stop();
      this.open = false;
      if (this.currentLog) {
        this.currentLog.timer = this.$timer({
          interval: 6,
          callback: () => {
            this.$state.ui.robotLogs.shift();
          }
        });
        if (!this.hasInfoMessages || this.currentLog.usedMachine) {
          this.open = false;
          this.currentLog.timer.start();
        } else {
          this.open = true;
        }
      }
    }
  },
  methods: {
    ToggleNotification: function () {
      if (this.hasInfoMessages) {
        this.open = !this.open;
        if (this.currentLog?.timer) {
          this.open ? this.currentLog.timer.pause() : this.currentLog.timer.start();
        }
      }
    }
  }
};